"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formControlLabelTheme = exports.default = void 0;

var formControlLabelTheme = function formControlLabelTheme(theme) {
  return {
    root: {
      '&.validation-text': {
        marginBottom: 17
      },
      '&.radio-hint-text': {
        marginBottom: 17
      },
      '&.validation-text.radio-hint-text': {
        marginBottom: 36
      },
      '&.conditional-text-field': {
        marginBottom: 51
      },
      '&.conditional-text-field.radio-hint-text': {
        marginBottom: 68
      }
    },
    label: {
      marginBottom: 0,
      fontFamily: 'Source Sans Pro',
      lineHeight: '20px',
      height: 20,
      '& > .bold': {
        fontWeight: 600
      },
      '& > .form-control-hint-text': {
        position: 'relative',
        top: 0,
        left: 0,
        fontFamily: 'Source Sans Pro',
        fontWeight: 400,
        color: theme.palette.text.secondary
      }
    },
    labelPlacementStart: {
      marginLeft: 0,
      '& > .MuiFormControlLabel-label': {
        marginRight: 16
      }
    }
  };
};

exports.formControlLabelTheme = formControlLabelTheme;
var _default = {
  formControlLabelTheme: formControlLabelTheme
};
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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